export default [
  {
    path: '/randevu-sonuc-tip-list',
    name: 'randevu-sonuc-tip-list',
    component: () => import('./index.vue'),
    meta: {
      public: false,
      title: 'randevu_sonuc_tip.Baslik',
      yetki: { k: [2000402] },
    },
  },
]
